import _ from 'underscore';
import ko from 'knockout';
import { StringRules } from './rules';
import { StringExtension } from './extension';

/**
 * define observable for string property
 * @param {Object} prop - property define
 * @param {string} value - initialize value of property
 * @param {Rules} extraRules - extended rules for this property
 * @param {I18n} i18n - get error message for rules
 * @returns {Observable} - return observable for property with string type
 */
export function KoSchemaString(prop, value, extraRules, i18n) {
  const rules = StringRules(prop, extraRules, i18n);
  const observable = ko.observable(value).extend({ validate: _.values(rules) });

  observable.validators = rules;

  StringExtension(observable, prop, i18n);

  return observable;
}
